const initialState = {
    loading: false,
    data: [],
    error: null,
  };
  
  const getAchievementReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_ACHIEVEMENT_REQUEST':
        return { ...state, loading: true, error: null };
      case 'FETCH_ACHIEVEMENT_SUCCESS':
        return { ...state, loading: false, data: action.payload, error: null };
      case 'FETCH_ACHIEVEMENT_FAILURE':
        return { ...state, loading: false, data: [], error: action.payload };
      case 'FETCH_ACHIEVEMENT_COMPLETE':
        return { ...state, loading: false };
      default:
        return state;
    }
  }; 
  
  export default getAchievementReducer;